'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var back = require('../../../../assets/images/back.png');
var home = require('../../../../assets/images/home.png');
var titleBox = require('../../../../assets/images/title-box.png');

var CommonBg = function (_Component) {
    _inherits(CommonBg, _Component);

    function CommonBg(props) {
        _classCallCheck(this, CommonBg);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            pageTitle: '智慧生涯',
            dayArray: ['日', '一', '二', '三', '四', '五', '六'],
            month: '',
            date: '', //日
            day: '', //星期
            hours: '',
            minutes: ''
        };
        return _this;
    }

    CommonBg.prototype._setPageTitle = function () {
        function _setPageTitle(title) {
            //各页面设置title
            this.setState({
                pageTitle: title
            });
        }

        return _setPageTitle;
    }();

    CommonBg.prototype._setTimeNow = function () {
        function _setTimeNow() {
            var timeNow = new Date();
            this.setState({
                month: timeNow.getMonth() < 9 ? '0' + (timeNow.getMonth() + 1) : timeNow.getMonth() + 1,
                date: timeNow.getDate() < 10 ? '0' + timeNow.getDate() : timeNow.getDate(),
                day: this.state.dayArray[timeNow.getDay()],
                hours: timeNow.getHours() < 10 ? '0' + timeNow.getHours() : timeNow.getHours(),
                minutes: timeNow.getMinutes() < 10 ? '0' + timeNow.getMinutes() : timeNow.getMinutes()
            });
        }

        return _setTimeNow;
    }();

    CommonBg.prototype.componentDidMount = function () {
        function componentDidMount() {
            var _this2 = this;

            this.timer && clearInterval(this.timer);
            this._setTimeNow();
            this.timer = setInterval(function () {
                _this2._setTimeNow();
            }, 60000);
        }

        return componentDidMount;
    }();

    CommonBg.prototype.componentWillUnmount = function () {
        function componentWillUnmount() {
            this.timer && clearInterval(this.timer);
        }

        return componentWillUnmount;
    }();

    CommonBg.prototype.render = function () {
        function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'common-back-box' },
                _react2.default.createElement(
                    'div',
                    { className: 'position-ab width-100 header-blocks z-index1' },
                    _react2.default.createElement('div', { className: 'width-100 header-block block-color1' }),
                    _react2.default.createElement('div', { className: 'width-100 header-block block-color2' })
                ),
                _react2.default.createElement('img', { className: 'position-ab title-box z-index2', src: titleBox }),
                _react2.default.createElement(
                    'div',
                    { className: 'page-title position-ab text-center fs3 fc2 z-index3' },
                    this.state.pageTitle
                ),
                this.props.pathname === '/' ? this.state.day ? _react2.default.createElement(
                    'div',
                    { className: 'time-now-box position-ab z-index3' },
                    _react2.default.createElement(
                        'span',
                        { className: 'margin-ri-18' },
                        this.state.month,
                        '\u6708',
                        this.state.date,
                        '\u65E5'
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'margin-ri-18' },
                        '\u661F\u671F',
                        this.state.day
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'margin-ri-30' },
                        this.state.hours,
                        ':',
                        this.state.minutes
                    )
                ) : null : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'return-back header-right-item z-index3', onClick: function () {
                                function onClick() {
                                    _reactRouter.browserHistory.go(-1);
                                }

                                return onClick;
                            }() },
                        _react2.default.createElement(
                            'span',
                            null,
                            '\u540E\u9000'
                        ),
                        _react2.default.createElement('img', { src: back })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'return-home header-right-item z-index3', onClick: function () {
                                function onClick() {
                                    _reactRouter.browserHistory.push('/');
                                }

                                return onClick;
                            }() },
                        _react2.default.createElement(
                            'span',
                            null,
                            '\u9996\u9875'
                        ),
                        _react2.default.createElement('img', { src: home })
                    )
                ),
                _react2.default.Children.map(this.props.children, function (child) {
                    return _react2.default.cloneElement(child, {
                        setPageTitle: function () {
                            function setPageTitle(title) {
                                return _this3._setPageTitle(title);
                            }

                            return setPageTitle;
                        }()
                    });
                })
            );
        }

        return render;
    }();

    return CommonBg;
}(_react.Component);

exports.default = CommonBg;


//////////////////
// WEBPACK FOOTER
// ./src/ui/component/common/CommonBg.js
// module id = 555
// module chunks = 0